import { axiosInstance } from '../Middleware'
import { ResponseGetAllType } from '../response'
import { PlageHoraireType } from './types'

export class PlagehoraireApi {
  public static loadPlageshoraires = (complement?: string) : Promise<ResponseGetAllType<PlageHoraireType>> =>
    axiosInstance.get(`/personnel/personnel/plageshoraires${complement ? `?${complement}` : ''}`)
      .then(response => response.data)

  public static loadHeures= (complement?: string) : Promise<PlageHoraireType[]> =>
    axiosInstance.get(`/personnel/personnel/plageshoraires/heure${complement ? `?${complement}` : ''}`)
      .then(response => response.data)
}
